export const LOGIN='LOGIN'
export const LOGOUT='LOGOUT'
export const APP_LOADED='َAPP_LOADED'
export const DATA='DATA'
export const COINCHANGE='COINCHANGE'
export const SETTINGS_FAQ='SETTINGS_FAQ'
export const SETTINGS_RULES='SETTINGS_RULES'
export const SETTINGS_RPIVACY='SETTINGS_RPIVACY'
export const SETTINGS_SUPPORT='SETTINGS_SUPPORT'
export const FREE='FREE'
export const STARS='STARS'
export const GIFTHALLDIALOG='GIFTHALLDIALOG'
export const QUESTIONNUMBER='QUESTIONNUMBER'
export const SILVERCOINVISIBLE='SILVERCOINVISIBLE'
export const GOLDENCOINVISIBLE='GOLDENCOINVISIBLE'
export const BOTHCOINVISIBLE='BOTHCOINVISIBLE'
export const DIALOGVISIBLE='DIALOGVISIBLE'
export const DIALOGDATA='DIALOGVISIBLE'
